import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertBanner = _resolveComponent("AlertBanner")!
  const _component_OfflineModal = _resolveComponent("OfflineModal")!
  const _component_PermissionsStepsGuide = _resolveComponent("PermissionsStepsGuide")!
  const _component_LocationBeggingModal = _resolveComponent("LocationBeggingModal")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_ctx.addedVars)
  }, [
    (_ctx.hasActiveBannerAlerts === true)
      ? (_openBlock(), _createBlock(_component_AlertBanner, {
          key: 0,
          alert: _ctx.bannerAlert
        }, null, 8, ["alert"]))
      : _createCommentVNode("", true),
    _createVNode(_component_OfflineModal),
    (_ctx.permissionsStepsGuideShown)
      ? (_openBlock(), _createBlock(_component_PermissionsStepsGuide, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.showLocationBeggingModal)
      ? (_openBlock(), _createBlock(_component_LocationBeggingModal, { key: 2 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 4))
}